
<div class="row preferences" foundation>
  <div class="column large-12 medium-12 small-12 foo-container icons-table">
    <div class="mt-3 mb-3 d-flex justify-content-end" style="padding: 0 20px">
      <div class="bold text user-limit-notes" *ngIf="usersInfo && (usersInfo.allowedUsers - usersInfo.existingUsers) > 0">
        <label>
          {{usersInfo.allowedUsers - usersInfo.existingUsers}} Seats left. <a class="pointer text-decoration-underline" (click)="addNewUser()">Click here</a> to add more.
        </label>
      </div>
      <div class="bold text user-limit-notes" *ngIf="usersInfo && (usersInfo.allowedUsers - usersInfo.existingUsers) <= 0">
        <label>
          No Seats left. <a class="pointer text-decoration-underline" (click)="addNewUser()">Add more</a> for ${{usersInfo.costForUser || ''}} per month.
        </label>
      </div>
      <div class="bold text user-limit-notes" *ngIf="currentPlan && (currentPlan.includes('Start-ASAP') || currentPlan.includes('Professional'))">
        <label>
          <a class="pointer text-decoration-underline" (click)="addNewUser()">Click here</a> to create user.
        </label>
      </div>
    </div>

    <div class="tab-container books-tab-container">
      <div class="row collapse tab-content">
        <div class="column medium-12">
          <app-tpiq-paginated-table [setObj]="usersTableData" *ngIf="hasUsersList" (onScroll)="handleScroll($event)" (onRowAction)="handleAction($event)"
                                 (onSort)="sortByColumn($event)"></app-tpiq-paginated-table>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="reveal['createOrUpdateUser']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['createOrUpdateUser']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 40%;" [ngClass]="{'tpiq-reveal': reveal['createOrUpdateUser']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">{{editMode ? 'Update User': 'Create a New User'}} </span>
      <span class="float-right pointer" (click)="hideReveal('createOrUpdateUser')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body" style="padding: 15px;">
      <div class="d-flex flex-column ps-3 pe-3 new-input-fields">
        <div class="d-flex flex-column w-100">
          <div>
            <label>First Name*</label>
          </div>
          <div>
            <label>
              <input type="text" [(ngModel)]="userData.firstName" placeholder="First Name"/>
            </label>
          </div>
        </div>
        <div class="d-flex flex-column w-100">
          <div>
            <label>Last Name*</label>
          </div>
          <div>
            <label>
              <input type="text" [(ngModel)]="userData.lastName" placeholder="Last Name"/>
            </label>
          </div>
        </div>
        <div class="d-flex flex-column">
          <div>
            <label>Email*</label>
          </div>
          <div>
            <label>
              <input type="text" [(ngModel)]="userData.id" placeholder="Email" [disabled]="editMode"/>
              <div class="error" *ngIf="userData.id && !isValidEmail(userData.id)">Please check email format</div>
            </label>
          </div>
        </div>
        <div class="d-flex flex-column">
          <div>
            <label>Phone</label>
          </div>
          <div>
            <label>
              <input type="text" input-mask [(ngModel)]="userData.phoneNumber" placeholder="Phone"/>
            </label>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-3">
          <button class="button small float-right" (click)="saveUser()">{{editMode? "Update": "Add"}}</button>
        </div>
      </div>
    </div>
  </div>
</div>


